import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const EditListPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [language1, setLanguage1] = useState('');
  const [language2, setLanguage2] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchList();
  }, [id]);

  const fetchList = async () => {
    try {
      const response = await api.get(`/lists/${id}`);
      const list = response.data;

      if (list.isQrImported) {
        // QR-imported lists cannot be edited
        navigate(`/lists/${id}`);
        return;
      }

      setName(list.name);
      setLanguage1(list.language1);
      setLanguage2(list.language2);
    } catch (err) {
      setError(err.message || t('errors.serverError'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim() || !language1.trim() || !language2.trim()) {
      setError(t('errors.required'));
      return;
    }

    setIsSubmitting(true);

    try {
      await api.put(`/lists/${id}`, {
        name: name.trim(),
        language1: language1.trim(),
        language2: language2.trim(),
      });
      navigate(`/lists/${id}`);
    } catch (err) {
      setError(err.message || t('errors.serverError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <button
        className="btn btn-outline"
        onClick={() => navigate(`/lists/${id}`)}
        style={{ marginBottom: '1rem' }}
      >
        &larr; {t('common.back')}
      </button>

      <h1 className="page-title">{t('lists.edit')}</h1>

      <form onSubmit={handleSubmit} className="card" style={{ marginTop: '1rem' }}>
        {error && (
          <div className="form-error" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="name" className="form-label">
            {t('lists.name')} *
          </label>
          <input
            type="text"
            id="name"
            className="form-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="language1" className="form-label">
            {t('lists.language1')} *
          </label>
          <input
            type="text"
            id="language1"
            className="form-input"
            value={language1}
            onChange={(e) => setLanguage1(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="language2" className="form-label">
            {t('lists.language2')} *
          </label>
          <input
            type="text"
            id="language2"
            className="form-input"
            value={language2}
            onChange={(e) => setLanguage2(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? t('common.loading') : t('common.save')}
          </button>
          <button
            type="button"
            className="btn btn-outline"
            onClick={() => navigate(`/lists/${id}`)}
          >
            {t('common.cancel')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditListPage;
